import { v4 as uuidv4 } from 'uuid';

export function generateReferenceId() {
	const now = new Date();
	// Get the parts of the date separately
	// We can reorder them and use two digits only for each part
	const twoDigitsDay = now.getDate().toString().padStart(2, '0');
	const twoDigitsMonth = (now.getMonth() + 1).toString().padStart(2, '0');
	const twoDigitsYear = now.getFullYear().toString().slice(2);

	// Generate the rest of the referenceId with UUID
	// By limiting date to 6 characters, the UUID will be 6 characters which will make it stronger for our purposes
	const uuid = uuidv4()
		.replace(/[^0-9]/g, '')
		.slice(0, 6);

	// Join the parts together with the date first in a user friendly order
	const referenceId = `${twoDigitsYear}${twoDigitsMonth}${twoDigitsDay}${uuid}`;

	return referenceId;
}
